var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { Link } from "react-router-dom";

import styles from "./NewsletterHeader.css";

var NewsletterHeader = function (_Component) {
  _inherits(NewsletterHeader, _Component);

  function NewsletterHeader() {
    _classCallCheck(this, NewsletterHeader);

    return _possibleConstructorReturn(this, (NewsletterHeader.__proto__ || Object.getPrototypeOf(NewsletterHeader)).apply(this, arguments));
  }

  _createClass(NewsletterHeader, [{
    key: "render",
    value: function render() {
      var newsletter = this.props.newsletter;

      if (!newsletter || !newsletter.authors || newsletter.authors.length === 0) return null;
      return React.createElement(
        "div",
        { className: styles.root },
        React.createElement(
          "span",
          { className: styles.heading },
          "By "
        ),
        newsletter.authors.map(function (author, index) {
          return React.createElement(
            Link,
            { key: author.username, to: "/authors/" + author.username, className: styles.author },
            author.display_name,
            index < newsletter.authors.length - 1 && ", "
          );
        })
      );
    }
  }]);

  return NewsletterHeader;
}(Component);

export default NewsletterHeader;


// WEBPACK FOOTER //
// ./src/subscriptions/components/NewsletterHeader/NewsletterHeader.js